export default {
  namespaced: true,
  state: {
    sales: [],
    sale: null,
    actions: [],
    action: null,
    categories: [],
    groups: [],
    products: [],
  },
  actions: {
    GetSalesList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'sales', value: [] });
      rootGetters.axl.post('sales/api/sale/list', payload)
        .then((response) => {
          commit('setField', { name: 'sales', value: response.data.sales });
        });
    },
    ConfirmAction({ dispatch, rootGetters }, payload) {
      rootGetters.axl.post('/actions/api/action/take-part', {
        profile_id: payload.profile_id,
        action_id: payload.action_id,
      })
        .then(() => {
          dispatch('GetActionsList', { profile_id: payload.profile_id });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },

    GetSale({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'sale', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('sales/api/sale/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'sale', value: response.data.sale });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetProductsList({ commit, rootGetters }) {
      return new Promise((resolve) => {
        commit('setField', { name: 'products', value: [] });
        rootGetters.ax.post('sales/api/product/list-products')
          .then((response) => {
            commit('setField', { name: 'products', value: response.data.products });
            resolve();
          });
      });
    },
    GetActionsList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'actions', value: [] });
      rootGetters.axl.post('actions/api/action/current-list', payload)
        .then((response) => {
          commit('setField', { name: 'actions', value: response.data.actions });
        });
    },
    GetAction({ commit, rootGetters, dispatch }, payload) {
      dispatch('ClearAction');
      if (payload.noClearSale === undefined) {
        dispatch('ClearSale');
      }
      rootGetters.axl.post('actions/api/action/view', payload)
        .then((response) => {
          commit('setField', { name: 'action', value: response.data.action });
          commit('setField', { name: 'categories', value: response.data.action.categories });
          commit('setField', { name: 'groups', value: response.data.action.groups });
          commit('setField', { name: 'products', value: response.data.action.products });
        });
    },
    ClearAction({ commit }) {
      commit('setField', { name: 'action', value: null });
      commit('setField', { name: 'categories', value: [] });
      commit('setField', { name: 'groups', value: [] });
      commit('setField', { name: 'products', value: [] });
    },
    ClearSale({ commit }) {
      commit('setField', { name: 'sale', value: null });
    },
    ClearSales({ commit }) {
      commit('setField', { name: 'sales', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
